import React, { createContext, useState } from 'react'; 

export const AppContext = createContext(null);

export const ContextWrapper = ({ children }) => {
    const [pageTransitionDuration, setPageTransitionDuration] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    
    return (
        <AppContext.Provider value={{
            pageTransitionDuration, setPageTransitionDuration,
            isLoading, setIsLoading,
        }}>
            {children}
        </AppContext.Provider>
    );
};
 